<!--- COMPONENTE PCVolcadosLinea  ---->
<!---
Descripción del componente:
---------------------------
- Incluye un tab con diferentes opciones y los ultimos volcados.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="div-componentePCVolcadosLinea">
    <f7-toolbar
      tabbar
      no-shadow
      no-hairline
      class="toolbar-resumenesVolcados"
      position="top"
    >
      <a
        href="#tab-1"
        class="tab-link tab-link-active"
      >
        <span class="tabbar-label"> {{ $t('production.common.recent') }}</span>
      </a>
      <a
        href="#tab-2"
        class="tab-link"
      >
        <span class="tabbar-label">{{ $t('production.common.byProducts') }}</span>
      </a>
    </f7-toolbar>
    <f7-tabs animated>
      <f7-tab
        id="tab-1"
        tab-active
      >
        <PCUltimosVolcados
          v-if="lineaDeProduccion != null && !lineaDeProduccion.GenerarLotesEnVolcado"
          ref="PCUltimosVolcados"
          :activo="activo"
          @volcado-seleccionado="VolcadoSeleccionado"
        />
        <PCUltimosVolcadosLote
          v-if="lineaDeProduccion != null && lineaDeProduccion.GenerarLotesEnVolcado"
          ref="PCUltimosVolcadosLote"
          :activo="activo"
          @volcado-seleccionado="VolcadoSeleccionado"
          @lote-activo="CargarLoteActivo"
        />
      </f7-tab>
      <f7-tab id="tab-2">
        <PCResumenFamiliasVolcados
          ref="PCResumenFamiliasVolcados"
          :activo="activo"
        />
      </f7-tab>
    </f7-tabs>
  </div>
</template>

<script>
import PCResumenFamiliasVolcados from '@/components/production/traceability/PCResumenFamiliasVolcados.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import PCUltimosVolcados from './PCUltimosVolcados.vue';
import PCUltimosVolcadosLote from './PCUltimosVolcadosLote.vue';

export default {
  name: 'PCVolcadosLinea',
  components: {
    PCUltimosVolcados,
    PCResumenFamiliasVolcados,
    PCUltimosVolcadosLote,

  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    lineaDeProduccion: {
      type: Object,
      default: null,
    },
  },

  emits: [
    'volcadoSeleccionado',
    'loteActivo',
  ],

  methods: {
    /**
     * @public
     * @returns {void}
     */
    ActualizarComponenteDeUltimosVolcados() {
      Log(this, this.ActualizarComponenteDeUltimosVolcados.name);
      this.ActualizarComponenteDeResumenFamilias();
      if (!this.lineaDeProduccion.GenerarLotesEnVolcado) {
        this.$refs.PCUltimosVolcados.ActualizarDatos();
      } else {
        this.$refs.PCUltimosVolcadosLote.ActualizarDatos();
      }
    },
    // Método ActualizarComponenteDeResumenFamilias
    ActualizarComponenteDeResumenFamilias() {
      Log(this, this.ActualizarComponenteDeResumenFamilias.name);
      this.$refs.PCResumenFamiliasVolcados.ActualizarDatos();
    },
    // Método VolcadoSeleccionado
    VolcadoSeleccionado(objVolcado) {
      Log(this, this.VolcadoSeleccionado.name);
      this.$emit('volcadoSeleccionado', objVolcado);
    },
    CargarLoteActivo(objLote) {
      Log(this, this.CargarLoteActivo.name);
      this.$emit('loteActivo', objLote);
    },
  },
};
</script>

<style scoped lang="scss">
.toolbar-resumenesVolcados {
  background: var(--his-tierra-white);
  top: 0;
  box-shadow: -1px 4px 5px 1px rgb(201 201 201 / 100%);

  :deep(.tab-link-highlight) {
    display: none;
  }
}

.tabbar-label {
  color: #24253d;
  text-transform: none;
  font-size: 22px;
}

.tab-link {
  border-right: 1px solid var(--his-silver);
  border-bottom: 4px solid transparent;
}

.tab-link-active {
  border-bottom: 4px solid var(--his-silver);
}
</style>
